/**
 * Pre-compiled en messages for RichTextInput
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  bold: `Bold`,
  bulletedList: `Bulleted list`,
  code: `Code`,
  headingFive: `Heading 5`,
  headingFour: `Heading 4`,
  headingOne: `Heading 1`,
  headingThree: `Heading 3`,
  headingTwo: `Heading 2`,
  italic: `Italic`,
  listFormatting: `List formatting`,
  moreFormattingOptions: `More formatting options`,
  moreStyles: `More styles`,
  numberedList: `Numbered list`,
  paragraph: `Paragraph`,
  quote: `Quote`,
  redo: `Redo`,
  strikethrough: `Strikethrough`,
  subscript: `Subscript`,
  superscript: `Superscript`,
  textFormatting: `Text formatting`,
  textStyle: `Text style`,
  textStyleMenu: `Text style menu`,
  underline: `Underline`,
  undo: `Undo`,
};
